import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    height: '60vh',
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.typography.fontFamily,
    color: theme.colors.grey.dark,
  }),
);

export const StyledErrorMessageTitle = styled('div')(() => ({
  fontSize: 30,
  fontWeight: 'bold',
  textAlign: 'center',
}));

export const StyledErrorMessageDetails = styled('div')(() => ({
  fontSize: 16,
  textAlign: 'center',
}));
